// GET /api/firm/workspace - the dashboard's Google Workspace tiles.
// No fixture fallback: an unreachable server throws, so the tiles render
// "Not verified" instead of inventing a connection state. needsAuth in a
// section is the server's own verdict and renders a connect path.

import { getAuthHeaders } from "./auth";

export interface WorkspaceGmailThread {
  threadId: string;
  subject?: string;
  from?: string;
  snippet?: string;
  internalDate?: string;
}

export interface WorkspaceDriveDoc {
  fileId: string;
  name: string;
  modifiedTime?: string;
}

export interface WorkspaceCalendarEvent {
  id: string;
  start: string;
  summary: string;
  location?: string;
  meetUrl?: string;
  attendees?: string[];
}

export interface FirmWorkspace {
  gmail: { threads: WorkspaceGmailThread[]; unread: number; needsAuth: boolean };
  drive: { recent: WorkspaceDriveDoc[]; touchedToday: number; needsAuth: boolean };
  calendar: {
    today: WorkspaceCalendarEvent[];
    nextHearing?: WorkspaceCalendarEvent;
    needsAuth: boolean;
  };
  syncedAt: string;
}

export async function fetchFirmWorkspace(): Promise<FirmWorkspace> {
  const res = await fetch("/api/firm/workspace", {
    headers: { ...getAuthHeaders() },
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`GET /api/firm/workspace failed: ${res.status}`);
  return (await res.json()) as FirmWorkspace;
}
